"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListSubheader = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ListSubheader = _interopRequireDefault(require("@material-ui/core/ListSubheader"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _styles2 = require("./styles.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ListSubheader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ListSubheader, _Component);

  var _super = _createSuper(ListSubheader);

  function ListSubheader() {
    var _this;

    (0, _classCallCheck2.default)(this, ListSubheader);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          className = _this$props.className,
          isSideNav = _this$props.isSideNav,
          classes = _this$props.classes,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["className", "isSideNav", "classes"]);
      return /*#__PURE__*/_react.default.createElement(_ListSubheader.default, (0, _extends2.default)({
        "aria-hidden": true // This item should not be read as part of the list. Instead use an aria-label on the list

      }, otherProps, {
        className: (0, _classnames.default)("prmbl-listSubheader", classes.root, className, (0, _defineProperty2.default)({}, classes.header, isSideNav === "header"), (0, _defineProperty2.default)({}, classes.subheader, isSideNav === "subheader"))
      }));
    });
    return _this;
  }

  return ListSubheader;
}(_react.Component);

exports.ListSubheader = ListSubheader;
(0, _defineProperty2.default)(ListSubheader, "propTypes", {
  /**
   * The html Id.
   */
  id: _propTypes.default.string.isRequired,

  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * If true, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: _propTypes.default.bool,

  /**
   * If true, the List Subheader will be indented.
   */
  inset: _propTypes.default.bool,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * Whether it is part of the side navigation
   */
  isSideNav: _propTypes.default.oneOf(["header", "subheader"]),

  /**
   * @ignore
   *
   * Utilizing this to pass styles from Page component
   */
  classes: _propTypes.default.object.isRequired
});
(0, _defineProperty2.default)(ListSubheader, "defaultProps", {
  disableSticky: false,
  inset: false,
  className: ""
});

var _default = (0, _styles.withStyles)(_styles2.styles)(ListSubheader);

exports.default = _default;